(() => {
  const money = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, format);
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return (format || '${{amount}}').replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, amount);
  };

  const swatchMap = {
    black:'#111111', midnight:'#111111', white:'#f5f2ea', ivory:'#eee8dc', cream:'#e8dfcf',
    burgundy:'#682638', wine:'#682638', red:'#9d2632', blue:'#315f9c', cobalt:'#1551a7',
    navy:'#17243d', lavender:'#a89ac7', purple:'#72598e', peach:'#dea58d', pink:'#d78da4',
    nude:'#c8ad95', tan:'#b99676', brown:'#6c4b38', green:'#536c55', mint:'#aac7b8', grey:'#858783', gray:'#858783'
  };
  const swatchColor = value => {
    const key = String(value || '').toLowerCase();
    return Object.entries(swatchMap).find(([name]) => key.includes(name))?.[1] || '#c9c2b8';
  };
  const readableText = hex => {
    const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#0b0b0b' : '#fff';
  };

  document.querySelectorAll('[data-ffp-swatch]').forEach(label => label.style.setProperty('--swatch', label.dataset.swatchColor || swatchColor(label.dataset.ffpSwatch)));

  /** Shared with the collection grid + homepage quick-add — see assets/ff-cart.js. */
  const cartSectionIds = () => window.FFCart ? window.FFCart.sectionIds() : [];
  const notifyHorizonCart = (lines, cart, sections) => window.FFCart ? window.FFCart.notify(lines, cart, sections) : Promise.resolve();

  document.querySelectorAll('[data-ffp-product-root]').forEach(root => {
    const variantsNode = root.querySelector('[data-ffp-product-json]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const inputs = [...root.querySelectorAll('[data-ffp-option-input]')];
    const idInput = root.querySelector('[data-ffp-variant-id]');
    const form = root.querySelector('[data-ffp-product-form]');
    const atc = root.querySelector('[data-ffp-atc]');
    const atcLabel = root.querySelector('[data-ffp-atc-label]');
    const sticky = root.querySelector('[data-ffp-sticky]');
    const stickyAtc = root.querySelector('[data-ffp-sticky-atc]');
    const error = root.querySelector('[data-ffp-form-error]');
    const inventory = root.querySelector('[data-ffp-inventory]');
    const format = root.dataset.moneyFormat;
    let selectedVariant = variants.find(v => String(v.id) === String(idInput?.value)) || variants[0];

    const selectedOptions = () => [...root.querySelectorAll('[data-ffp-option]')].map(group => group.querySelector('input:checked')?.value || '');
    const findVariant = () => variants.find(v => v.options.every((option, index) => option === selectedOptions()[index]));

    const filterGallery = variant => {
      if (!variant) return;
      const options = selectedOptions();
      const colourGroup = [...root.querySelectorAll('[data-ffp-option]')].find(group => /colou?r/i.test(group.querySelector('legend')?.textContent || ''));
      const colour = colourGroup ? colourGroup.querySelector('input:checked')?.value : '';
      const cards = [...root.querySelectorAll('[data-ffp-media]')];
      const tagged = cards.some(card => /(?:\[?colou?r\s*:\s*)/i.test(card.dataset.mediaAlt || ''));
      cards.forEach(card => {
        if (!tagged || !colour) { card.hidden = false; return; }
        const alt = (card.dataset.mediaAlt || '').toLowerCase();
        const isTagged = /(?:\[?colou?r\s*:\s*)/i.test(alt);
        card.hidden = isTagged && !alt.includes(colour.toLowerCase());
      });
      const featuredId = String(variant.featured_media?.id || variant.featured_image?.id || '');
      const featured = cards.find(card => card.dataset.mediaId === featuredId && !card.hidden);
      if (featured && window.innerWidth <= 640) featured.scrollIntoView({ behavior:'smooth', block:'nearest', inline:'start' });
      updateGalleryProgress();
    };

    const updateGalleryProgress = () => {
      const gallery = root.querySelector('[data-ffp-gallery]');
      const bar = root.querySelector('[data-ffp-gallery-progress]');
      if (!gallery || !bar) return;
      const visible = [...gallery.querySelectorAll('[data-ffp-media]')].filter(card => !card.hidden);
      const index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      bar.style.width = `${Math.max(1, Math.min(index + 1, visible.length)) / Math.max(visible.length, 1) * 100}%`;
    };

    const update = () => {
      selectedVariant = findVariant();
      root.querySelectorAll('[data-ffp-option]').forEach(group => {
        const label = group.querySelector('[data-ffp-option-label]');
        const checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });
      const notify = root.querySelector('[data-ffp-notify-toggle]');
      if (!selectedVariant) {
        atc.disabled = true;
        atcLabel.textContent = 'Unavailable combination';
        stickyAtc.disabled = true;
        stickyAtc.textContent = 'Unavailable';
        inventory.textContent = 'This option combination is not available.';
        if (notify) notify.hidden = true;
        return;
      }
      idInput.value = selectedVariant.id;
      const available = Boolean(selectedVariant.available);
      root.querySelector('[data-ffp-price]').textContent = money(selectedVariant.price, format);
      const compare = root.querySelector('[data-ffp-compare]');
      if (selectedVariant.compare_at_price > selectedVariant.price) {
        compare.hidden = false; compare.textContent = money(selectedVariant.compare_at_price, format);
      } else compare.hidden = true;
      atc.disabled = !available;
      atcLabel.textContent = available ? 'Add to cart' : 'Sold out';
      stickyAtc.disabled = !available;
      stickyAtc.textContent = available ? 'Add to cart' : 'Sold out';
      if (notify) { notify.hidden = available; notify.dataset.variantId = selectedVariant.id; notify.dataset.variantTitle = selectedVariant.title; }
      root.querySelector('[data-ffp-sticky-variant]').textContent = selectedVariant.title;
      root.querySelector('[data-ffp-sticky-price]').textContent = money(selectedVariant.price, format);
      inventory.textContent = available ? '' : 'Selected variant is currently unavailable.';
      history.replaceState({}, '', `${root.dataset.productUrl}?variant=${selectedVariant.id}`);
      filterGallery(selectedVariant);

      const colourGroup = root.querySelector('.ffp-option--color');
      const colourInput = colourGroup?.querySelector('input:checked');
      const colourValue = colourInput?.value;
      if (colourValue) {
        const colourLabel = colourInput.id ? root.querySelector('label[for="' + colourInput.id + '"]') : null;
        const accent = colourLabel?.dataset.swatchColor || swatchColor(colourValue);
        const text = readableText(accent);
        [atc, stickyAtc].forEach(btn => {
          if (!btn) return;
          btn.style.setProperty('--ffp-atc-accent', accent);
          btn.style.setProperty('--ffp-atc-text', text);
        });
      }
    };

    inputs.forEach(input => input.addEventListener('change', update));
    update();

    const gallery = root.querySelector('[data-ffp-gallery]');
    gallery?.addEventListener('scroll', updateGalleryProgress, { passive:true });
    const galleryStep = direction => gallery?.scrollBy({ left: direction * gallery.clientWidth, behavior:'smooth' });
    root.querySelector('[data-ffp-gallery-prev]')?.addEventListener('click', () => galleryStep(-1));
    root.querySelector('[data-ffp-gallery-next]')?.addEventListener('click', () => galleryStep(1));

    const announce = message => {
      const toast = root.querySelector('[data-ffp-toast]');
      if (!toast) return;
      toast.textContent = message; toast.classList.add('is-visible');
      clearTimeout(toast._timer); toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
    };

    const add = async formData => {
      error?.classList.remove('is-visible');
      const sectionIds = cartSectionIds();
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method:'POST', headers:{ Accept:'application/json' }, body:formData });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers:{ Accept:'application/json' } }).then(r => r.json());
      notifyHorizonCart([{ merchandiseId: `gid://shopify/ProductVariant/${selectedVariant.id}`, quantity: 1 }], cart, data.sections);
      announce('Added to your cart');
      return data;
    };

    form?.addEventListener('submit', async event => {
      event.preventDefault();
      if (!selectedVariant?.available) return;
      atc.disabled = true;
      try { await add(new FormData(form)); }
      catch (err) { if (error) { error.textContent = err.message; error.classList.add('is-visible'); } }
      finally { atc.disabled = !selectedVariant.available; }
    });
    stickyAtc?.addEventListener('click', () => form?.requestSubmit());

    if (atc && sticky) {
      const syncSticky = () => sticky.classList.toggle('is-visible', atc.getBoundingClientRect().bottom < 0);
      window.addEventListener('scroll', syncSticky, { passive:true });
      window.addEventListener('resize', syncSticky, { passive:true });
      syncSticky();
    }
  });


  const sizeGuideOverlay = document.querySelector('[data-ff-size-guide-overlay]');
  if (sizeGuideOverlay) {
    const setSizeGuideOpen = open => {
      sizeGuideOverlay.classList.toggle('is-open', open);
      sizeGuideOverlay.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    document.querySelectorAll('[data-ff-size-guide-toggle]').forEach(toggle => {
      toggle.addEventListener('click', () => setSizeGuideOpen(true));
    });
    sizeGuideOverlay.querySelectorAll('[data-ff-size-guide-close]').forEach(el => {
      el.addEventListener('click', () => setSizeGuideOpen(false));
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && sizeGuideOverlay.classList.contains('is-open')) setSizeGuideOpen(false);
    });
  }

  const notifyOverlay = document.querySelector('[data-ffp-notify-overlay]');
  if (notifyOverlay) {
    const notifyForm = notifyOverlay.querySelector('[data-ffp-notify-form]');
    const notifyStatus = notifyOverlay.querySelector('[data-ffp-notify-status]');
    const notifyLine = notifyOverlay.querySelector('[data-ffp-notify-variant-line]');
    const notifySubmit = notifyOverlay.querySelector('[data-ffp-notify-submit]');
    let activeNotify = { variantId: '', variantTitle: '', productTitle: '' };

    const setNotifyOpen = open => {
      notifyOverlay.classList.toggle('is-open', open);
      notifyOverlay.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { notifyStatus.textContent = ''; notifyForm.hidden = false; notifySubmit.disabled = false; }
    };

    document.querySelectorAll('[data-ffp-notify-toggle]').forEach(toggle => {
      toggle.addEventListener('click', () => {
        activeNotify = {
          variantId: toggle.dataset.variantId || '',
          variantTitle: toggle.dataset.variantTitle || '',
          productTitle: toggle.dataset.productTitle || ''
        };
        notifyLine.textContent = `We'll text and email you the moment "${activeNotify.productTitle}" (${activeNotify.variantTitle}) is back.`;
        setNotifyOpen(true);
      });
    });
    notifyOverlay.querySelectorAll('[data-ffp-notify-close]').forEach(el => {
      el.addEventListener('click', () => setNotifyOpen(false));
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && notifyOverlay.classList.contains('is-open')) setNotifyOpen(false);
    });

    notifyForm.addEventListener('submit', e => {
      e.preventDefault();
      const email = notifyForm.querySelector('[data-ffp-notify-email]').value.trim();
      const phone = notifyForm.querySelector('[data-ffp-notify-phone]').value.trim();
      if (!email || !phone) { notifyStatus.textContent = 'Please enter both your email and phone number.'; return; }
      notifySubmit.disabled = true;
      notifyStatus.textContent = 'Sending…';

      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { '$email': email, '$phone_number': phone }]);
      window._learnq.push(['track', 'Notify Me Request', {
        ProductName: activeNotify.productTitle,
        Variant: activeNotify.variantTitle,
        VariantId: activeNotify.variantId,
        Email: email,
        Phone: phone
      }]);

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'contact',
          utf8: '✓',
          'contact[email]': email,
          'contact[phone]': phone,
          'contact[body]': `Notify me when available request for "${activeNotify.productTitle}" — ${activeNotify.variantTitle} (variant ${activeNotify.variantId}). Phone: ${phone}`
        })
      }).catch(() => {}).finally(() => {
        notifyStatus.textContent = "You're on the list — we'll reach out as soon as it's back.";
        notifyForm.hidden = true;
        setTimeout(() => setNotifyOpen(false), 2200);
      });
    });
  }

  document.querySelectorAll('[data-ffp-testimonials]').forEach(root => {
    const track = root.querySelector('[data-ffp-testimonials-track]');
    const slides = [...track.children];
    if (slides.length < 2) return;
    const dots = [...root.querySelectorAll('[data-ffp-testimonials-dot]')];
    let index = 0;
    let auto;
    const goTo = i => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, di) => dot.classList.toggle('is-active', di === index));
    };
    const restartAuto = () => { clearInterval(auto); auto = setInterval(() => goTo(index + 1), 6000); };
    root.querySelector('[data-ffp-testimonials-prev]')?.addEventListener('click', () => { goTo(index - 1); restartAuto(); });
    root.querySelector('[data-ffp-testimonials-next]')?.addEventListener('click', () => { goTo(index + 1); restartAuto(); });
    dots.forEach((dot, di) => dot.addEventListener('click', () => { goTo(di); restartAuto(); }));
    root.addEventListener('mouseenter', () => clearInterval(auto));
    root.addEventListener('mouseleave', restartAuto);
    restartAuto();
  });

  document.querySelectorAll('[data-ffp-recommendations]').forEach(section => {
    if (section.dataset.loaded === 'true') return;
    const url = section.dataset.url;
    if (!url) return;
    fetch(url).then(response => response.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = doc.querySelector(`[data-ffp-recommendations][data-section-id="${section.dataset.sectionId}"]`);
      if (replacement?.innerHTML.trim()) {
        section.innerHTML = replacement.innerHTML;
        delete section.dataset.ffCollectionReady;
        if (window.FFCollection) window.FFCollection.init(section);
      }
    }).catch(() => {});
  });

  // Kaching Bundles hides our picker and drives it from its own selectors. Its default variants are
  // set per deal in the app admin and can sell out, so freshly rendered items move to an available
  // option; the Add to Cart guard stops a selected bundle from failing silently on a sold-out piece.
  const kachingSeen = new WeakMap();
  const unavailable = option => !option || option.disabled || /unavailable/i.test(option.textContent);
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));

  const repairKachingItem = async item => {
    const pillGroup = [...item.querySelectorAll('.kaching-bundles__pill-buttons')]
      .find(group => group.querySelector('.kaching-bundles__pill-buttons__button--selected.kaching-bundles__pill-buttons__button--unavailable'));
    if (pillGroup) {
      const pill = [...pillGroup.querySelectorAll('.kaching-bundles__pill-buttons__button')]
        .find(button => !button.classList.contains('kaching-bundles__pill-buttons__button--unavailable'));
      if (pill) {
        pill.click();
        await pause(400);
        if (item.classList.contains('kaching-bundles__bar-variant--invalid')) repairKachingItem(item);
        return;
      }
    }
    const swatch = [...item.querySelectorAll('.kaching-bundles__swatch-buttons')]
      .find(group => group.querySelector('.kaching-bundles__swatch-buttons__button--selected .kaching-bundles__swatch--unavailable'));
    if (swatch) {
      const button = [...swatch.querySelectorAll('.kaching-bundles__swatch-buttons__button')]
        .find(el => !el.querySelector('.kaching-bundles__swatch--unavailable') && !el.classList.contains('kaching-bundles__swatch-buttons__button--selected'));
      if (button) {
        button.click();
        await pause(400);
        if (item.classList.contains('kaching-bundles__bar-variant--invalid')) repairKachingItem(item);
        return;
      }
    }
    const select = [...item.querySelectorAll('select.kaching-bundles-option')].find(el => unavailable(el.selectedOptions[0]));
    const fallback = select && [...select.options].find(option => !unavailable(option));
    if (fallback) {
      select.value = fallback.value;
      select.dispatchEvent(new Event('change', { bubbles:true }));
      return;
    }
    const combobox = item.querySelector('.kaching-bundles__swatch-dropdown [role="combobox"]');
    if (!combobox) return;
    combobox.click();
    await pause(250);
    const list = document.getElementById(combobox.getAttribute('aria-controls'));
    const current = combobox.closest('.kaching-bundles__swatch-dropdown').dataset.value;
    const colour = list && [...list.querySelectorAll('[role="option"]')].find(option => !/unavailable/i.test(option.textContent) && option.textContent.trim() !== current);
    if (!colour) { combobox.click(); return; }
    colour.click();
    await pause(400);
    if (item.classList.contains('kaching-bundles__bar-variant--invalid')) repairKachingItem(item);
  };

  const watchKaching = block => {
    if (block.dataset.ffpWatched) return;
    block.dataset.ffpWatched = 'true';
    let queued;
    const scan = () => {
      block.querySelectorAll('.kaching-bundles__bar-variant').forEach(item => {
        if (!kachingSeen.has(item)) kachingSeen.set(item, { at: Date.now(), repaired: false });
        const seen = kachingSeen.get(item);
        if (seen.repaired || Date.now() - seen.at > 2500 || !item.classList.contains('kaching-bundles__bar-variant--invalid')) return;
        seen.repaired = true;
        repairKachingItem(item);
      });
    };
    new MutationObserver(() => { clearTimeout(queued); queued = setTimeout(scan, 150); }).observe(block, { subtree:true, childList:true, attributes:true, attributeFilter:['class'] });
    scan();
  };

  document.querySelectorAll('[data-ffp-product-root]').forEach(root => {
    const atc = root.querySelector('[data-ffp-atc]');
    const error = root.querySelector('[data-ffp-form-error]');
    atc?.addEventListener('click', event => {
      if (!document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-variant--invalid')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (error) {
        error.textContent = 'One piece in this bundle is sold out in that option. Choose another size or colour to continue.';
        error.classList.add('is-visible');
      }
    }, true);
    let attempts = 0;
    const poll = setInterval(() => {
      const block = document.querySelector('.kaching-bundles');
      if (block) { clearInterval(poll); watchKaching(block); }
      else if (++attempts > 60) clearInterval(poll);
    }, 250);
  });
})();

/* ffp-colour-lead: chosen colour's photo leads the gallery */
(() => {
  const gallery = document.querySelector('[data-ffp-gallery]');
  const jsonEl = document.querySelector('[data-ffp-product-json]');
  if (!gallery || !jsonEl) return;
  let variants;
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  const cards = [...gallery.querySelectorAll('[data-ffp-media]')];
  if (cards.length < 2) return;
  const colourGroup = [...document.querySelectorAll('[data-ffp-option]')].find(g => /colou?r/i.test(g.querySelector('legend')?.textContent || ''));
  if (!colourGroup) return;
  const colourIndex = Number(colourGroup.dataset.position) - 1;
  const byColour = new Map();
  variants.forEach(v => {
    const colour = String(v.options?.[colourIndex] || '').toLowerCase();
    const media = String(v.featured_media?.id || '');
    if (!colour || !media) return;
    if (!byColour.has(colour)) byColour.set(colour, new Set());
    byColour.get(colour).add(media);
  });
  let current = '';
  const showColour = name => {
    const key = String(name || '').trim().toLowerCase();
    const ids = byColour.get(key);
    if (!ids || key === current) return;
    const lead = cards.filter(card => ids.has(card.dataset.mediaId));
    if (!lead.length) return;
    current = key;
    [...lead, ...cards.filter(card => !lead.includes(card))].forEach((card, i) => {
      gallery.appendChild(card);
      const n = card.querySelector('.ffp-media-index');
      if (n) n.textContent = (i + 1) + ' / ' + cards.length;
    });
    gallery.scrollTo({ left: 0 });
    if (window.innerWidth > 900) {
      const top = gallery.getBoundingClientRect().top;
      if (top < 0) window.scrollBy({ top: top - 110, behavior: 'smooth' });
    }
  };
  const fromKaching = target => {
    const bar = target.closest('.kaching-bundles__bar');
    const item = target.closest('.kaching-bundles__bar-variant');
    if (!bar || !item || item !== bar.querySelector('.kaching-bundles__bar-variant')) return null;
    return target;
  };
  const onPick = event => {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    const swatch = event.target.closest?.('.kaching-bundles__swatch-buttons__button');
    if (swatch && fromKaching(swatch)) showColour(swatch.dataset.value);
  };
  document.addEventListener('click', onPick);
  document.addEventListener('keydown', onPick);
  document.addEventListener('change', event => {
    const el = event.target;
    if (el.matches?.('select.kaching-bundles-option') && fromKaching(el)) showColour(el.value || el.selectedOptions?.[0]?.textContent);
    const group = el.closest?.('[data-ffp-option]');
    if (group && group === colourGroup && el.matches('input')) showColour(el.value);
  });
})();

/* ffp-panel-pin: pin the buy panel so its bottom (colour, size, add to cart) stays in view */
(() => {
  const panel = document.querySelector('.ffp-product-panel');
  if (!panel) return;
  const desktop = window.matchMedia('(min-width:901px)');
  const update = () => {
    if (!desktop.matches) { panel.style.removeProperty('--ffp-panel-top'); return; }
    const atc = panel.querySelector('[data-ffp-atc]');
    if (!atc) return;
    const reach = atc.getBoundingClientRect().bottom - panel.getBoundingClientRect().top;
    panel.style.setProperty('--ffp-panel-top', Math.min(32, Math.round(window.innerHeight - reach - 24)) + 'px');
  };
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(panel);
  window.addEventListener('resize', update);
  update();
})();

/* ffp-wheel-forward: wheel over a full-screen app popup (e.g. Klaviyo) still scrolls the page */
(() => {
  const pw = document.querySelector('.page-wrapper');
  if (!pw) return;
  document.addEventListener('wheel', e => {
    if (e.ctrlKey || pw.contains(e.target) || pw.scrollHeight <= pw.clientHeight) return;
    if (e.target.closest('.ff-mobile-drawer,.ff-size-guide-modal,.ffp-notify-modal,.ff-search-panel,.kaching-bundles')) return;
    pw.scrollTop += e.deltaY;
  }, { passive: true, capture: true });
})();
